module.exports = __webpack_public_path__ + "static/img/homeleft4.06a7d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeleft4.png
// module id = kBpO
// module chunks = 13